import ApplicationSTD from "./components/ApplicationSTD";
import ApplicationCDLI from "./components/ApplicationCDLI";
import ApplicationDBTIMakati from "./components/ApplicationDBTIMakati";
import { ApplicationMakati } from "./components/ApplicationMakati";
// TVET overlay: 1TVET's own static application form, kept byte-identical to
// 1TVET-UI/src/pages/ApplicationPage/component/ApplicationSTD.js so the two trees can be diffed.
// CampusCloud's ApplicationSTD is the dynamic form and needs application_form_* tables that no
// TVET campus database has, which is why TVET keys must not fall through to it.
import { ApplicationSTD as ApplicationTvetSTD } from "./components/ApplicationTvetSTD";
import { isTvetTenant } from "../../misc/TvetTenant";

export function Application() {

   var subdomain = localStorage.getItem("lms-subdomain");

   const application = () => {
      const components = {
         'dbti-makati': ApplicationDBTIMakati,
         'localhost': ApplicationSTD,
         'casadellibroinc': ApplicationCDLI,
         'makati': ApplicationMakati
      };

      // CampusCloud keys keep CampusCloud's form; the ten TVET campus keys get 1TVET's.
      const fallback = isTvetTenant(subdomain) ? ApplicationTvetSTD : ApplicationSTD;
      const Component = components[subdomain] || fallback;
      return <Component />;
   };

   return (
      <>
         {
            application()
         }
      </>
   )
}
